import InvoiceInterface from "../interface/invoiceInterface";
import React from "react";
import InvoiceGeneratorController from "../../invoiceGenerator/controller/invoiceGeneratorController";
import AppSettingController from "../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../Main/interface/MarketSettingLocalStorage";
import MarketRepository from "../../Main/repository/MarketRepository";
import MarketCartLocalstorage, {ProductState} from "../../Main/interface/MarketCartLocalstorage";
import {get, map, reject, toNumber} from "lodash";
import CheckAvailableProductController from "./CheckAvailableProductController";
import PayManager from "../../Pay/controller/PayManager";
import {NavigateFunction} from "react-router-dom";
import AppOrdersController from "../../Main/controller/AppOrdersController";
import EventController from "../../../controller/EventController";
import DiscountController from "./DiscountController";
import LogController from "../../../controller/LogController";
import i18n from "../../../i18n";
import {withLang} from "../../../routes/LangLayout";

export default class PaymentManager {
    protected state: InvoiceInterface;
    protected setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>;

    constructor(state: InvoiceInterface, setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>) {
        this.state = state;
        this.setState = setState;
    }


    async payment(deskLabel: string | undefined, shopId: string, navigator: NavigateFunction, manual?: 'pos' | 'cash') {
        const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;

        LogController.log("request payment", "paymentEvent", {paymentMode: setting.marketMode})

        this.updateState({loading: true})

        const hasValidProducts = await this.removeCustomOrdersInCard(shopId);
        if (!hasValidProducts) return;

        this.updateState({notAvailableProduct: []})

        const products = map(card.items, (item: any) => ({
            count: item.quantity,
            id: item._id,
            name: item.title,
            price: item.final_price ? item.final_price : item.price
        }));

        if (this.state.price.regular === 0) {
            AppSettingController.setPosOrCash('cash')
            return await this.payWithoutPos(products, deskLabel, navigator, shopId)
        }


        if (manual === 'pos') {
            AppSettingController.setPosOrCash('pos')
            return await this.payWithPos(products, deskLabel, navigator, shopId)
        }

        if (manual === 'cash') {
            AppSettingController.setPosOrCash('cash')
            return await this.payWithoutPos(products, deskLabel, navigator, shopId)
        }

        if (this.state.price.regular > 0 && AppSettingController.isActivePayment())
            await this.payWithPos(products, deskLabel, navigator, shopId)

        if (this.state.price.regular === 0 || !AppSettingController.isActivePayment())
            await this.payWithoutPos(products, deskLabel, navigator, shopId)
    }

    private async payWithPos(products: any, deskLabel: string | undefined, navigator: NavigateFunction, shopId: string) {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
        const desk = deskLabel ? deskLabel : i18n.t("invoice.takeout");
        const now = new Date();
        const formattedDate = now.toISOString().replace('T', ' ').split('.')[0];

        const price = {
            total: this.state.price.total,
            regular: this.state.price.regular,
            isApplyDiscount: this.state.discount.isApplyDiscount,
            discountType: this.state.discount.type as string,
        }
        const payment = await new PayManager({
            amount: ((setting.currency === "\ufdfc" || setting.currency === "ریال") && setting.service === "netbee") ? this.state.price.total : this.state.price.total * 10
        }, navigator, shopId).pay();
        if (payment.status && payment.data) {
            AppOrdersController.setOrder({
                shopId,
                price,
                order: {
                    products: products,
                    payAt: formattedDate,
                    rrn: get(JSON.parse(get(payment, "data", "")), "data.rrn", ""),
                    trace: get(JSON.parse(get(payment, "data", "")), "data.trace", ""),
                },
                syncServer: false,
                desk: desk
            })

            EventController.dispatch("syncServer")

            AppSettingController.changeReceiptNumber(toNumber(setting.receipt) + 1)

            await AppSettingController.generateBarcode()

            const invoiceTimeout = setTimeout(async () => {
                await this.printInvoice(desk)
                clearTimeout(invoiceTimeout)
            }, 500)

            const redirect = setTimeout(async () => {
                navigator(withLang(`/success/${shopId}`), {replace: true});
                this.updateState({loading: false})
                clearTimeout(redirect)
            }, 1000)
        }
    }

    private async payWithoutPos(products: any, deskLabel: string | undefined, navigator: NavigateFunction, shopId: string) {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;
        const desk = deskLabel ? deskLabel : i18n.t("invoice.takeout");
        const now = new Date();
        const formattedDate = now.toISOString().replace('T', ' ').split('.')[0];
        new DiscountController(this.state, this.setState).calculationPrice()

        const price = {
            total: this.state.price.total,
            regular: this.state.price.regular,
            isApplyDiscount: this.state.discount.isApplyDiscount,
            discountType: this.state.discount.type as string,
        }

        AppSettingController.changeReceiptNumber(toNumber(setting.receipt) + 1)
        const setOrderObject = {
            shopId,
            price,
            order: {
                products,
                payAt: formattedDate,
                rrn: '',
                trace: '',
            },
            syncServer: false,
            desk
        }

        LogController.log("payment with cash", "cash-payment", setOrderObject)

        await AppSettingController.generateBarcode()


        const invoiceTimeout = setTimeout(async () => {
            await this.printInvoice(desk)
            clearTimeout(invoiceTimeout)
        }, 500)

        const redirect = setTimeout(async () => {
            navigator(withLang(`/success/${shopId}`), {replace: true});
            this.updateState({loading: false})

            AppOrdersController.setOrder(setOrderObject);

            EventController.dispatch("syncServer")
            clearTimeout(redirect)
        }, 1000)
    }

    private async removeCustomOrdersInCard(shopId: string): Promise<boolean> {
        const card = MarketRepository.getCartMarket() as MarketCartLocalstorage;

        const filteredItems = reject(
            card.items,
            (item: ProductState) => get(item, "customProduct") === true
        );

        const checkProduct = await new CheckAvailableProductController(
            this.state,
            this.setState
        ).checkOrders(filteredItems as ProductState[], shopId);

        if (
            (!get(checkProduct, "payment", true) && !filteredItems.length) ||
            checkProduct?.invalidItems.length
        ) {
            this.updateState({
                notAvailableProduct: get(checkProduct, "invalidItems", []),
                loading: false,
                showPaymentMethod: false,
            });
            return false
        }

        return true;
    }

    async printInvoice(desk: string | undefined) {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;

        new InvoiceGeneratorController().downloadImage(this.state, setting.activeDesk ? desk : undefined)

        setting.printer?.map(async (item) => {
            await new InvoiceGeneratorController().print(this.state, setting.activeDesk ? desk : undefined, item.ip, item.port)
        })
    }

    private updateState(state: Partial<InvoiceInterface>) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}
